module.exports = __webpack_public_path__ + "img/Left Image.5c52047f.png";